import { LitElement, html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { SideMenuEvents, SideMenuPosition, SideMenuWidthValues } from '../types';
import { ResizableMixin } from '../../../mixins';

export class GzSideMenuWebComponent extends ResizableMixin(LitElement) {
  /**
   * The default menu width is 300px.
   */
  @property({ attribute: true, reflect: true })
  menuWidth = SideMenuWidthValues.SMALL;

  /**
   * The side menu is as tall as its container and can be aligned to left or right. The default alignment is to the
   * right side of the container.
   */
  @property({ type: String, attribute: true, reflect: true })
  menuPosition = SideMenuPosition.RIGHT;

  @property({ type: Boolean, attribute: true, reflect: true })
  isOpen = false;

  @property({ type: Boolean, attribute: true, reflect: true })
  isResponsive = false;

  /**
   * Setting this property to 'true' will close the side menu when the user clicks outside the menu
   */
  @property({ type: Boolean, reflect: true })
  closeOnClickOutside = false;

  @query('#sideMenuContent')
  private sideMenuContent: HTMLElement;

  @query('#sideMenu')
  private sideMenu: HTMLElement;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="overlay" @click="${this.handleOverlayClick}">
        <div class="side-menu ${this.resizable ? 'resize-content' : ''}" id="sideMenu">
          <gz-icon-button
            @click="${this.closeSideMenu}"
            class="side-menu--button"
            icon="ds-icon-clear"
            size="24"
            fontsize="20"
            buttontype="square"
            buttonfill="quiet"
            buttoncolor="secondary"
          >
          </gz-icon-button>
          ${this.renderHandler()}
          <div class="side-menu--content" id="sideMenuContent">
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  private renderHandler() {
    if (this.resizable) {
      return this.renderResizeHandler();
    }
  }

  public openSideMenu() {
    if (this.resizable) {
      this.sideMenu.style.width = parseFloat(this.menuWidth) + 'px';
    }
    this.isOpen = true;
    this.dispatchEvent(
      new CustomEvent(SideMenuEvents.OPEN, {
        bubbles: true,
      })
    );
  }

  public closeSideMenu(fireEvent = true) {
    this.isOpen = false;

    if (fireEvent) {
      this.dispatchEvent(
        new CustomEvent(SideMenuEvents.CLOSE, {
          bubbles: true,
          composed: true
        })
      );
    }
  }

  private onOverlayClick(event: Event) {
    /**
     * Close the side menu only when the overlay is clicked
     */
    if (event.target !== event.currentTarget) {
      return;
    }
    this.closeSideMenu();
  }
  private handleOverlayClick(event) {
    if (!this.closeOnClickOutside) {
      return;
    }
    this.onOverlayClick(event);
  }

  public setMenuContent(template: HTMLElement | null) {
    this.innerHTML = '';
    if (template) {
      this.appendChild(template);
    }
  }
}
